import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

import { Button } from '../atoms/Button';

import { Modal } from '../molecules/Modal';

interface ModalProps {
  isOpen: boolean;
  loading?: boolean;
  onClose: () => void;
  onYes: () => void;
}

const QuestionAttentionOfInsertingImageModalFooter: React.FC<ModalProps> = (props) => {
  return (
    <Buttons>
      <Button onClick={props.onClose} gray>
        キャンセル
      </Button>
      <Button onClick={props.onYes}>はい</Button>
    </Buttons>
  );
};

export const QuestionAttentionOfInsertingImageModal: React.FC<ModalProps> = (props) => {
  return (
    <Modal
      header={<Header>注意</Header>}
      footer={<QuestionAttentionOfInsertingImageModalFooter {...props} />}
      isOpen={props.isOpen}
      onClose={props.onClose}
      loading={props.loading}
      width="576px"
    >
      <Container>
        {
          <>
            <p>画像が含まれる質問をした場合、AI先生による即時回答はできません。</p>
            <br />
            <p>
              この場合、講師による回答に切り替わります。通常より、回答に時間がかかる場合があります。
            </p>
            <br />
            <p>よろしいですか？</p>
          </>
        }
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  padding: 2rem 3rem;

  p {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  ${media.lessThan('medium')`
  padding: 1rem 1.5rem;
    p {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
`}
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

const Header = styled.h2`
  width: 100%;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
`;
